import { useToggleState } from '@cian/react-utils';
import { FaqItem } from 'shared/components/FaqItem';
import { openQuestion } from 'shared/components/tracking';
import { IFaqItem } from 'shared/types/faq';

export const FaqItemContainer: React.FC<IFaqItem> = props => {
  const { state: visible, toggle: toggleVisible } = useToggleState(false);

  const handleVisible = () => {
    if (!visible) {
      openQuestion();
    }
    toggleVisible();
  };

  return <FaqItem onChangeVisible={handleVisible} visible={visible} {...props} />;
};
